import { X } from 'lucide-react';

// Desktop-style window with title bar and close button
function DesktopWindow({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 pb-16">
      <div className="bg-background rounded-lg shadow-2xl w-[80%] h-[80%] flex flex-col resize overflow-hidden">
        {/* Title bar */}
        <div className="flex items-center justify-between border-b border-border px-3 py-2 flex-shrink-0">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button onClick={onClose} className="p-1 hover:bg-muted rounded">
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden rounded-b-lg">
          {children}
        </div>
      </div>
    </div>
  );
}

export default DesktopWindow;
